import SecurityStandards from "./SecurityStandards";
import WhatGaitIs from "./WhatGaitIs";
import HowItWorks from "./HowItWorks";
import Quickstart from "./Quickstart";
import PeopleAndApplications from "./PeopleAndApplications";
import IsolationAndSetup from "./IsolationAndSetup";
import GettingStarted from "./GettingStarted";
import ConnectingYourSoftware from "./ConnectingYourSoftware";
import AddGaitSignIn from "./AddGaitSignIn";
import GaitSdk from "./GaitSdk";
import SecurityChecksAndFindings from "./SecurityChecksAndFindings";
import TeamsRolesAndInvites from "./TeamsRolesAndInvites";
import ApplicationsAndConnectionKeys from "./ApplicationsAndConnectionKeys";
import Glossary from "./Glossary";
import Troubleshooting from "./Troubleshooting";
import AutomatedSecurityResponse from "./AutomatedSecurityResponse";
import TwoStepVerification from "./TwoStepVerification";
import FaqPage from "./Faq";
import HowGaitProtectsYourData from "./HowGaitProtectsYourData";
import ReportAVulnerability from "./ReportAVulnerability";
import WhatsLive from "./WhatsLive";
import HandleAFinding from "./HandleAFinding";
import LocalToProduction from "./LocalToProduction";
import ProductOrganizationsAndInvites from "./ProductOrganizationsAndInvites";
import RotateAConnectionKey from "./RotateAConnectionKey";

/** Page body per slug. Titles and order live in ../manifest.js. */
export const DOC_CONTENT = {
    "what-gait-is": WhatGaitIs,
    "how-it-works": HowItWorks,
    quickstart: Quickstart,
    "people-and-applications": PeopleAndApplications,
    isolation: IsolationAndSetup,
    "getting-started": GettingStarted,
    "connecting-your-software": ConnectingYourSoftware,
    "gait-sdk": GaitSdk,
    "add-gait-sign-in": AddGaitSignIn,
    "security-checks-and-findings": SecurityChecksAndFindings,
    "teams-roles-and-invites": TeamsRolesAndInvites,
    "applications-and-connection-keys": ApplicationsAndConnectionKeys,
    glossary: Glossary,
    troubleshooting: Troubleshooting,
    "automated-security-response": AutomatedSecurityResponse,
    "two-step-verification": TwoStepVerification,
    faq: FaqPage,
    "how-gait-protects-your-data": HowGaitProtectsYourData,
    "report-a-vulnerability": ReportAVulnerability,
    "whats-live": WhatsLive,
    "security-standards": SecurityStandards,
    "handle-a-finding": HandleAFinding,
    "local-to-production": LocalToProduction,
    "product-organizations-and-invites": ProductOrganizationsAndInvites,
    "rotate-a-connection-key": RotateAConnectionKey,
};
